<form [formGroup]="forgotForm" (keyup.enter)="forgotForm.valid ? onSubmit() : ''">
    @if(forgotPasswordDetails.token) {
    <div>
        <div class="form-floating mt-4">
            <input class="form-control px-4 password"
                [ngClass]="showPassword ? 'form-control password-input ' : 'form-control password-input pw'"
                autocomplete="off" type="text" [placeholder]="'SIGN_IN.PASSWORD' | translate"
                formControlName="password" />
            <label class="mandatory">{{'SIGN_IN.PASSWORD' | translate}}</label>
            @if (!showPassword) {
            <span class="password-eye-icon" (click)="showPassword = !showPassword">
                <img class="" src="assets/icons/view-stroke-rounded.svg" />
            </span>
            }
            @else {
            <span class="password-eye-icon" (click)="showPassword = !showPassword">
                <img class="" src="assets/icons/view-off-slash-stroke-rounded.svg" />
            </span>
            }
            <app-validation-message [control]="forgotForm.get('password')" [formSubmission]="isSubmitted"
                [customErrorMessages]="passwordCustomValidation"></app-validation-message>
        </div>
    </div>
    <div>
        <div class="form-floating my-4">
            <input class="password px-4"
                [ngClass]="showConfrimPassword ? 'form-control password-input ' : 'form-control password-input pw'"
                type="text" autocomplete="off" placeholder="{{'FORGOT.CONFIRM_PASSWORD' | translate}}"
                formControlName="confirmPassword" [appConfirmPassword]="this.forgotForm.get('password')" />
            <label class="mandatory">{{'FORGOT.CONFIRM_PASSWORD' | translate}}</label>
            @if (!showConfrimPassword) {
            <span class="password-eye-icon" (click)="showConfrimPassword = !showConfrimPassword">
                <img class="" src="assets/icons/view-stroke-rounded.svg" />
            </span>
            } @else {
            <span class="password-eye-icon" (click)="showConfrimPassword = !showConfrimPassword">
                <img class="" src="assets/icons/view-off-slash-stroke-rounded.svg" />
            </span>
            }
            <app-validation-message [control]="forgotForm.get('confirmPassword')"
                [formSubmission]="isSubmitted"></app-validation-message>
        </div>
    </div>
    <button [disabled]="!forgotForm.valid" type="button" (click)="onSubmit()" class="btn-1 w-100 p-2 my-3">
        {{'FORGOT.CHANGE_PASSWORD_BUTTON' | translate}}
    </button>
    }@else {
    <app-email-verification [parentComponent]="componentName" />
    }
</form>